import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "h-100 d-flex flex-column commerce" };
const _hoisted_2 = { class: "header-bar" };
const _hoisted_3 = { class: "container g-main__header" };
const _hoisted_4 = ["title"];
const _hoisted_5 = { class: "align-self-center flex-grow-1 ps-3 pe-3 d-none d-lg-flex" };
const _hoisted_6 = { class: "align-self-center d-flex" };
const _hoisted_7 = {
    key: 0,
    class: "nav-item nav-entry nav-entry__user"
};
const _hoisted_8 = { class: "d-flex" };
const _hoisted_9 = { class: "caption d-none d-md-flex" };
const _hoisted_10 = { class: "text-muted" };
const _hoisted_11 = { class: "text" };
const _hoisted_12 = { class: "icon-container" };
const _hoisted_13 = ["title"];
const _hoisted_14 = { class: "content" };
const _hoisted_15 = {
    key: 1,
    class: "nav-item nav-entry nav-entry__user",
    style: { "padding-left": "0px" }
};
const _hoisted_16 = { class: "d-flex" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "caption" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "text-muted" }, "Kundenkonto"),
    /*#__PURE__*/ _createElementVNode("span", { class: "text-primary" }, "Jetzt anmelden...")
], -1);
const _hoisted_18 = { class: "icon-container" };
const _hoisted_19 = ["title"];
const _hoisted_20 = { class: "content" };
const _hoisted_21 = {
    key: 2,
    class: "nav-entry nav-entry__logout"
};
const _hoisted_22 = { class: "d-flex" };
const _hoisted_23 = { class: "icon-container" };
const _hoisted_24 = ["title"];
const _hoisted_25 = { class: "content" };
const _hoisted_26 = { class: "navbar navbar-expand-lg d-none d-lg-block main-nav" };
const _hoisted_27 = { class: "container" };
const _hoisted_28 = { class: "collapse navbar-collapse" };
const _hoisted_29 = {
    key: 0,
    class: "navbar-nav"
};
const _hoisted_30 = { class: "nav-item" };
const _hoisted_31 = ["src"];
const _hoisted_32 = { class: "collapse navbar-collapse justify-content-end" };
const _hoisted_33 = {
    key: 0,
    class: "navbar-nav"
};
const _hoisted_34 = { class: "nav-item" };
const _hoisted_35 = ["src"];
const _hoisted_36 = { class: "d-block d-lg-none g-mobile__header" };
const _hoisted_37 = { class: "container wrapper" };
const _hoisted_38 = { class: "menu-box" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "currentColor"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }),
    /*#__PURE__*/ _createElementVNode("path", { d: "M3 4h18v2H3V4zm0 7h12v2H3v-2zm0 7h18v2H3v-2z" })
], -1);
const _hoisted_40 = [
    _hoisted_39
];
const _hoisted_41 = { class: "search-box" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_ecommerce__message_bar = _resolveComponent("g-ecommerce__message-bar");
    const _component_g_sticky_bar = _resolveComponent("g-sticky-bar");
    const _component_g_logo = _resolveComponent("g-logo");
    const _component_router_link = _resolveComponent("router-link");
    const _component_g_ecommerce_box_search = _resolveComponent("g-ecommerce-box-search");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_ecommerce__account = _resolveComponent("g-ecommerce__account");
    const _component_g_ecommerce__carts = _resolveComponent("g-ecommerce__carts");
    const _component_g_ecommerce__request = _resolveComponent("g-ecommerce__request");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_navview = _resolveComponent("g-navview");
    const _component_g_ecommerce_footer = _resolveComponent("g-ecommerce-footer");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_g_ecommerce__message_bar),
        _createVNode(_component_g_sticky_bar, { "bar-object": _ctx.getStickyMenu }, null, 8, ["bar-object"]),
        _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                    class: "align-self-center mt-2 mb-2",
                    title: _ctx.$host.config.title
                }, [
                    _createVNode(_component_router_link, { to: "/" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_g_logo)
                        ]),
                        _: 1
                    })
                ], 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_g_ecommerce_box_search)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (_ctx.hasUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$tc('client.Identity.Profile.Current')), 1),
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userDisplayName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_router_link, { to: "/service/profile" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: "icon",
                                                title: _ctx.$tc('client.Identity.Profile.Current')
                                            }, [
                                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.userInitials), 1)
                                            ], 8, _hoisted_13)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_router_link, { to: "/login" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: "icon",
                                                title: _ctx.$tc('client.Identity.Profile.Current')
                                            }, [
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createVNode(_component_g_icon, {
                                                        width: "16",
                                                        height: "16",
                                                        src: "/assets/icons/person.svg",
                                                        style: { "margin-bottom": "2px" }
                                                    })
                                                ])
                                            ], 8, _hoisted_19)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ])),
                    _createVNode(_component_g_ecommerce__account),
                    _createVNode(_component_g_ecommerce__carts),
                    _createVNode(_component_g_ecommerce__request),
                    (_ctx.hasUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_router_link, { to: "/logout" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: "icon",
                                                title: _ctx.$tc('client.Common.Logout')
                                            }, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _createVNode(_component_g_icon, {
                                                        width: "16",
                                                        height: "16",
                                                        src: "/assets/icons/box-arrow-right.svg",
                                                        style: { "margin-bottom": "2px" }
                                                    })
                                                ])
                                            ], 8, _hoisted_24)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _createElementVNode("nav", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        (_ctx.mainMenuEntriesLeft.length > 0)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuEntriesLeft, (menuItem) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: "nav-link"
                                        }, {
                                            default: _withCtx(() => [
                                                (menuItem.iconUrl)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: menuItem.iconUrl
                                                    }, null, 8, _hoisted_31))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(" " + _toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target"])
                                    ]));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                        (_ctx.mainMenuEntriesRight.length > 0)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuEntriesRight, (menuItem) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_34, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: "nav-link"
                                        }, {
                                            default: _withCtx(() => [
                                                (menuItem.iconUrl)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: menuItem.iconUrl
                                                    }, null, 8, _hoisted_35))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(" " + _toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target"])
                                    ]));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                            class: "btn-nav",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.onMobileNavToogle && _ctx.onMobileNavToogle(...args))),
                            type: "button"
                        }, _hoisted_40)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_g_ecommerce_box_search, { mode: "mobile" }),
                        _createVNode(_component_g_navview)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", {
            class: _normalizeClass([_ctx.widthMode === 'full' ? 'container-fluid' : 'container']),
            style: { "flex": "1 1 0", "order": "2" }
        }, [
            _renderSlot(_ctx.$slots, "default")
        ], 2),
        _createVNode(_component_g_ecommerce_footer)
    ]));
}
